/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

import { Component, inject, ChangeDetectionStrategy } from '@angular/core'
import { Observable } from 'rxjs'
import { OrganisationContactInformation } from '../../models/organisation-contact-information'
import { SignupService } from '../../services/signup/signup.service'
import { filter, map } from 'rxjs/operators'

@Component({
  selector: 'myprofile-signup-ui-contact-box',
  templateUrl: './contact-box.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ContactBoxComponent {
  private _signupService = inject(SignupService)

  public readonly contactInformation$: Observable<OrganisationContactInformation | null>

  constructor() {
    this.contactInformation$ = this._signupService.getContactOrganisation().pipe(
      filter((data) => !!data && data.length > 0),
      map((data) => data[0]),
    )
  }

  contactEmailLinkOut(contactEmail: string): string {
    return `mailto:${contactEmail}`
  }

  /**
   * Builds a `tel:` URI from a human-formatted telephone number.
   * RFC 3966 only allows digits, leading `+`, and a few separators; spaces, parentheses,
   * dashes and slashes confuse some dialers, so we strip everything except digits and `+`.
   */
  telephoneLinkOut(telephoneNumber: string): string {
    const sanitized = telephoneNumber.replace(/[^\d+]/g, '')
    return `tel:${sanitized}`
  }
}
